import { ColDef, ValueFormatterParams } from '@ag-grid-community/core'
import { formatDate } from 'utils/helpers/date'

export const getColumns = () =>
  [
    { headerName: 'Barcode', field: 'catalogue', minWidth: 200 },
    { headerName: 'Store Code', field: 'storeCode', minWidth: 150 },
    {
      headerName: 'Added On',
      field: 'createdAt',
      minWidth: 180,
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
  ] as ColDef[]
